import sessionDetail from '../components/sessionDetail.vue'
import programDisplay from '../components/program.vue'
import expertsListing from '../components/expertsListing.vue'
import expertDetail from '../components/expertDetail.vue'
import trackDetail from '../components/trackPage.vue'



const routes = [
  {
    path: '/',
    name: 'program',
    props: true,
    component: programDisplay,
  },
  {
    path: '/session/:slug',
    name: 'sessionDetail',
    component: sessionDetail,
  },
  {
    path: '/speakers',
    name: 'expertsListing',
    component: expertsListing,

  },
  {
    path: '/track/:slug',
    name: 'trackDetail',
    component: trackDetail,
  },
  {
    path: '/speaker/:slug',
    name: 'expertDetail',
    component: expertDetail
  }
]

export default routes
